const animation = () => {
    $('.animate_afc, .animate_afc-light, .animate_afl, .animate_afr, .animate_aft, .animate_afb, .animate_wfc, .animate_hfc, .animate_rfc, .animate_rfl, .animate_rfr').waypoint({
        handler: function() {
            let el = $(this.element);

            if ( !el.hasClass('animate_start') ) {
                el.addClass('animate_start');
            }
        },
        offset: '105%',
        context: document.getElementById('website-wrapper')
    });
}